import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13a77ff4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-0 m-0" }
const _hoisted_2 = {
  class: "row m-0 menu",
  id: ""
}
const _hoisted_3 = { class: "col-12 m-0 d-flex justify-content-around menu-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "row m-0 p-0 sbLsit"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-0 m-0 d-flex title justify-content-center" }
const _hoisted_8 = { class: "d-inline-block" }
const _hoisted_9 = { class: "d-inline-block align-content-center desc" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "row m-0 p-0 sbLsit" }
const _hoisted_12 = { class: "col-12 p-0 m-0 d-flex flex-column justify-content-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block title" }, " 自主研发专利证书")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block desc" }, "我们在产品的功能研发上倾注大量的心血，经过数年积累沉淀，高田的设计团队研发出多项领先技术。产品外观性，实用性，更有特色的设计，我们自主研发同步滑翔系统、角度智能适应系统、BAS智能支撑系统、A’PAS智能坐姿适应系统、双弹簧卧式线控底盘等多项研发成果荣获2项国家发明专利，及多项实用新型专利和多项外观设计专利。", -1))
const _hoisted_15 = { class: "row m-0 p-0 sbLsit" }
const _hoisted_16 = { class: "col-12 p-0 m-0 d-flex flex-column justify-content-center" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block title" }, " 产品设计奖项证书")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block desc" }, "我们的产品设计充满了前瞻的时尚和动感，独具高田风格。高田研发设计的产品荣获2012中国家具设计奖银奖，第二十九届中国广州国际家具博览会银奖，第十三届中国家具设计奖铜奖等多项办公椅家具设计奖项。", -1))
const _hoisted_19 = { class: "row m-0 p-0 sbLsit" }
const _hoisted_20 = { class: "col-12 p-0 m-0 d-flex flex-column justify-content-center" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block title" }, " 外观功能设计奖项")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-block desc" }, "我们在产品的功能研发上倾注大量的心血，经过数年积累沉淀，高田的设计团队研发出多项领先技术。产品外观性，实用性，更有特色的设计，我们自主研发同步滑翔系统、角度智能适应系统、BAS智能支撑系统、A’PAS智能坐姿适应系统、双弹簧卧式线控底盘等多项研发成果荣获2项国家发明专利，及多项实用新型专利和多项外观设计专利。", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_jian_dan_lb = _resolveComponent("jian-dan-lb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menu, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["d-inline-block menu-list-title", { menuListTitleActive: item.active }]),
            key: index,
            onClick: ($event: any) => (_ctx.changeMenu(index))
          }, _toDisplayString(item.name), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    (_ctx.menu[0].active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.showData?.sb, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "col-12 p-0 m-0 d-flex flex-column justify-content-center"
            }, [
              _createElementVNode("img", {
                src: _ctx.url + item.cover_url,
                class: "w-100 align-content-center"
              }, null, 8, _hoisted_6),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(item.desc), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.menu[1].active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", null, [
                _createVNode(_component_jian_dan_lb, {
                  data: _ctx.data.showData?.zs_1,
                  index: 'zs_1'
                }, null, 8, ["data"])
              ]),
              _hoisted_13,
              _hoisted_14
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", null, [
                _createVNode(_component_jian_dan_lb, {
                  data: _ctx.data.showData?.zs_2,
                  index: 'zs_2'
                }, null, 8, ["data"])
              ]),
              _hoisted_17,
              _hoisted_18
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", null, [
                _createVNode(_component_jian_dan_lb, {
                  data: _ctx.data.showData?.zs_3,
                  index: 'zs_3'
                }, null, 8, ["data"])
              ]),
              _hoisted_21,
              _hoisted_22
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}